export default __webpack_public_path__ + "images/cleaning.58cf20b8b08b9027c7eafefb526fadb8.svg";